import React, { FC } from 'react';
import cn from 'classnames';

import st from './Categories.module.css';
import CategoriesList from '../CategoriesList';

type CategoriesProps = {
  category?: any;
  categories: [any];
  onCategorySelect: (selectCategory: any) => void;
};

const Categories: FC<CategoriesProps> = ({
  category = null,
  categories,
  onCategorySelect,
}) => (
  <div className={cn(st.categories, 'scroll')}>
    <CategoriesList
      buttonTestId="catalogCategoryButton"
      categories={categories}
      category={category}
      onCategorySelect={onCategorySelect}
    />
  </div>
);

export default Categories;
